import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var EnumPipe = /** @class */ (function () {
    function EnumPipe(fuseTranslationLoaderService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    EnumPipe.prototype.transform = function (value, entityType) {
        value = value.split(/(?=[A-Z])/).map(function (s) { return s.toUpperCase(); }).join('_');
        var translateKey = "ENUM." + entityType.toUpperCase() + "." + value;
        return this.translateService.instant(translateKey);
    };
    return EnumPipe;
}());
export { EnumPipe };
